import React from 'react';
interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}
export function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-id="element-43">
      <div className="bg-slate-800 p-4 rounded-full mb-4 text-slate-400" data-id="element-44">
        {icon}
      </div>
      <h3 className="text-lg font-medium text-white mb-2" data-id="element-45">{title}</h3>
      <p className="text-slate-400 text-sm max-w-xs mb-6" data-id="element-46">{description}</p>
      {action}
    </div>;
}